/**
 * @generated SignedSource<<972f8d57e29b3237822a005f803eb6ef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type digitalArchiveLinkTopicUrlPath$data = {
  readonly item: {
    readonly topics?: ReadonlyArray<{
      readonly name: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "digitalArchiveLinkTopicUrlPath";
};
export type digitalArchiveLinkTopicUrlPath$key = {
  readonly " $data"?: digitalArchiveLinkTopicUrlPath$data;
  readonly " $fragmentSpreads": FragmentRefs<"digitalArchiveLinkTopicUrlPath">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "digitalArchiveLinkTopicUrlPath",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "item",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Topic",
              "kind": "LinkedField",
              "name": "topics",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "type": "Content",
          "abstractKey": "__isContent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UrlPath",
  "abstractKey": null
};

(node as any).hash = "da545ef78f58656d7b1586295a8632f3";

export default node;
